import { put, call, all, select, takeLatest } from 'redux-saga/effects'

import { CONTENT_TYPE_CHANGED, BRAND_CHANGED, INTERVAL_CHANGED, FIELD_CHANGED, FETCH_BRANDS_AGGREGATES, FETCH_CONTENT_TYPES_AGGREGATES, FETCH_DOCUMENTS_AGGREGATES } from '../actions/types'

import {
  fetchBrandsAggregatesSuccess,
  fetchBrandsAggregatesFailure,
  fetchContentTypesAggregatesSuccess,
  fetchContentTypesAggregatesFailure,
  fetchDocumentsAggregatesSuccess,
  fetchDocumentsAggregatesFailure,
  fetchBrandsAggregates,
  fetchContentTypesAggregates,
  fetchDocumentsAggregates,
} from '../actions/elasticAggregatesActions'

import elasticService from '../services/elasticService'
import { fieldSelector, intervalSelector, contentTypeSelector, brandSelector } from '../selectors/elasticAggregatesSelectors'

function* handleContentTypeChanged(action) {
  const { contentType, accessToken } = action.payload
  const field = yield select(fieldSelector)
  const interval = yield select(intervalSelector)
  const brand = yield select(brandSelector)

  yield put(fetchBrandsAggregates(contentType, field, interval, accessToken))
  yield put(fetchDocumentsAggregates(brand, contentType, field, interval, accessToken))
}

function* handleBrandChanged(action) {
  const { brand, accessToken } = action.payload
  const field = yield select(fieldSelector)
  const interval = yield select(intervalSelector)
  const contentType = yield select(contentTypeSelector)

  yield put(fetchContentTypesAggregates(brand, field, interval, accessToken))
  yield put(fetchDocumentsAggregates(brand, contentType, field, interval, accessToken))
}

function* handleIntervalChanged(action) {
  const { interval, accessToken } = action.payload
  const field = yield select(fieldSelector)
  const brand = yield select(brandSelector)
  const contentType = yield select(contentTypeSelector)

  yield put(fetchBrandsAggregates(contentType, field, interval, accessToken))
  yield put(fetchContentTypesAggregates(brand, field, interval, accessToken))
  yield put(fetchDocumentsAggregates(brand, contentType, field, interval, accessToken))
}

function* handleFieldChanged(action) {
  const { field, accessToken } = action.payload
  const interval = yield select(intervalSelector)
  const brand = yield select(brandSelector)
  const contentType = yield select(contentTypeSelector)

  yield put(fetchBrandsAggregates(contentType, field, interval, accessToken))
  yield put(fetchContentTypesAggregates(brand, field, interval, accessToken))
  yield put(fetchDocumentsAggregates(brand, contentType, field, interval, accessToken))
}

function* handleFetchBrandsAggregates(action) {
  const { contentType, field, interval, accessToken } = action.payload

  try {
    // Fetch data from API
    const { data } = yield call(elasticService.aggregateByBrands, accessToken, contentType, field, interval)

    yield put(fetchBrandsAggregatesSuccess(data))
  } catch (err) {
    console.error(err, 'Error fetching elastic templates')
    yield put(fetchBrandsAggregatesFailure(err))
  }
}

function* handleFetchContentTypesAggregates(action) {
  const { brand, field, interval, accessToken } = action.payload

  try {
    // Fetch data from API
    const { data } = yield call(elasticService.aggregateByContentTypes, accessToken, brand, field, interval)

    yield put(fetchContentTypesAggregatesSuccess(data))
  } catch (err) {
    console.error(err, 'Error fetching elastic templates')
    yield put(fetchContentTypesAggregatesFailure(err))
  }
}

function* handleFetchDocumentsAggregates(action) {
  const { brand, contentType, field, interval, accessToken } = action.payload

  try {
    // Fetch data from API
    const { data } = yield call(elasticService.aggregateByDocumentCounts, accessToken, brand, contentType, field, interval)

    yield put(fetchDocumentsAggregatesSuccess(data))
  } catch (err) {
    console.error(err, 'Error fetching elastic templates')
    yield put(fetchDocumentsAggregatesFailure(err))
  }
}

function* watchElasticTemplatesSagas() {
  yield all([
    takeLatest(CONTENT_TYPE_CHANGED, handleContentTypeChanged),
    takeLatest(BRAND_CHANGED, handleBrandChanged),
    takeLatest(INTERVAL_CHANGED, handleIntervalChanged),
    takeLatest(FIELD_CHANGED, handleFieldChanged),
    takeLatest(FETCH_BRANDS_AGGREGATES, handleFetchBrandsAggregates),
    takeLatest(FETCH_CONTENT_TYPES_AGGREGATES, handleFetchContentTypesAggregates),
    takeLatest(FETCH_DOCUMENTS_AGGREGATES, handleFetchDocumentsAggregates),
  ])
}

export default watchElasticTemplatesSagas
